import React from "react";
import "./ApostilleCountriesList.css";

const countries = [
  "Grenada",
  "Kazakhstan",
  " Saint Vincent And Grenadines",
  "Greece",
  "Botswana",
  "Brunei Darussalam",
  "Burundi",
  "Dominica",
  "Cape Verde",
  "Cook Islands",
  "Belgium",
  "Belize",
  "Bosnia And Herzegovina",
  "Brazil",
  "Bulgaria",
  "Burkina Faso",
  "Canada",
  "Chile",
  "Costa Rica",
  "Croatia",
  "Cyprus",
  "Czech Republic",
  "Ecuador",
  "El Salvador",
  "Estonia",
  "Fiji",
  "France",
  "Georgia",
  "Honduras",
  "Iceland",
  "Ireland",
  "Israel",
  "Italy",
  "Japan",
  "Latvia",
  "Hong Kong",
  "Lithuania",
  "Luxembourg",
  "Malta",
  "Mexico",
  "Moldova",
  "Monaco",
  "Montenegro",
  "Nicaragua",
  "Norway",
  "Panama",
  "Peru",
  "Portugal",
  "Serbia",
  "Singapore",
  "Slovakia",
  "Slovenia",
  "Niue",
  "Lesotho",
  "Liberia",
  "Liechtenstein",
  "Malawi",
  "Morocco",
  "Saint LuciaTonga",
  "Philippines",
  "Samoa",
  "Kosovo",
  "South Korea",
  "Spain",
  "Sweden",
  "Switzerland",
  "Turkey",
  "Ukraine",
  "Uruguay",
  "Uzbekistan",
  "Argentina",
  "Armenia",
  "Austria",
  "Bahamas",
  "Belarus",
  "Denmark",
  "Dominican Republic",
  "Finland",
  "Germany",
  "Guatemala",
  "Hungary",
  "Macedonia",
  "Mauritius",
  "Netherlands",
  "Andorra",
  "Marshall Islands",
  "Antigua And Barbuda",
  "Barbados",
  "Bolivia",
  "Kyrgyzstan",
  "Namibia",
  "Tajikistan",
  "Tunisia",
  "Vanuatu",
  "Sao Tome And Principe",
  "New Zealand",
  "Poland",
  "Turkmenistan",
  "Albania",
  "Australia",
  "Bahrain",
  "Colombia",
  "Oman",
  "Paraguay",
  "Romania",
  "Russia",
  "South Africa",
  "Trinidad And Tobago",
  "UK",
  "USA",
  "Venezuela",
  "Azerbaijan",
  "India",
  "Mongolia",
  "Suriname",
  "Macau",
  "Saint Kitts And Nevis",
  "San Marino",
  "Swaziland",
  "Seychelles",
];

const ApostilleCountriesList = () => {
  return (
    <div className="apostilleCountriesList-container" id="europeCountryList">
      <h2 className="acl-title">
        {" "}
        List of <span>Hague Convention Countries</span>
      </h2>
      <ul className="acl-list">
        {countries.map((country, index) => (
          <li key={index} className="acl-item">
            {country}
          </li>
        ))}
      </ul>
    </div>
  );
};

export default ApostilleCountriesList;
